import { render, staticRenderFns } from "./importTemplateDialog.vue?vue&type=template&id=b3a0585a&scoped=true"
import script from "./importTemplateDialog.vue?vue&type=script&lang=js"
export * from "./importTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./importTemplateDialog.vue?vue&type=style&index=0&id=b3a0585a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a0585a",
  null
  
)

export default component.exports